import httpClient from "./httpClient";

class AssetService {
    async getAssets(channelGuid, data) {
        return httpClient(`/${channelGuid}/assets`, { method: "POST", body: data });
    }

    async updateDownloadCount(channelGuid, data) {
        return httpClient(`/${channelGuid}/assets/download-count`, { method: "POST", body: data });
    }

    async getAssetDetails(channelGuid, assetId) {
        return httpClient(`/${channelGuid}/assets/${assetId}`);
    }
}

export default new AssetService(); 